import React, { useState, useEffect } from 'react';
import { Empty, Button, Pagination, Checkbox, Space, Dropdown, Menu, Input, Divider, Badge, Select } from 'antd';
import {
  UserOutlined,
  PlusOutlined,
  CaretDownOutlined,
  UnorderedListOutlined,
  DeleteOutlined,
  DownOutlined,
  UpOutlined,
  CheckCircleFilled,
  ImportOutlined,
  WarningOutlined,
  EditOutlined,
  FilterOutlined,
  CaretUpOutlined, SearchOutlined
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { style, title, value, p1, p2 } = props;
  return (
    <div style={style} className="statictis-container">
      <div className="statictis-container title">
        {title}
      </div>
      <div className="statictis-container value">
        {value}
        <div className="p">
          <div className="tong">
            同比:<span style={{color:'red',fontWeight:'500'}}>10% ↑</span>
            </div>
          <div className="huan">
            环比:<span style={{color:'#00ff00', fontWeight:'500'}}>10% ↓</span>
              </div>
        </div>
      </div>
    </div>
  );
});
